import { SelectedFilters } from '@/components/FilterData/types';
import { api } from '@/services/api';
import { normalizeSelectedFilters, normalizePage, normalizePerPage } from '@/components/Search/utils';

export const CROSS_TENANT_TEXT_SEARCH_QUERY_KEY = 'crossTenant.textSearch';

export const queryKey = ({
  searchQuery,
  selectedFilters,
  page,
  perPage,
  tenantId,
}: {
  searchQuery: string;
  selectedFilters?: SelectedFilters;
  page?: string | number;
  perPage?: string | number;
  tenantId: string;
}) => [
  CROSS_TENANT_TEXT_SEARCH_QUERY_KEY,
  {
    searchQuery,
    selectedFilters: normalizeSelectedFilters(selectedFilters),
    page: normalizePage(page),
    perPage: normalizePerPage(perPage),
    tenantId,
  },
];

export const queryFunction =
  ({
    searchQuery,
    selectedFilters,
    page,
    perPage,
    tenantId,
  }: {
    searchQuery: string;
    selectedFilters?: SelectedFilters;
    page?: string | number;
    perPage?: string | number;
    tenantId: string;
  }) =>
  () =>
    api.crossTenant.textSearch(tenantId, {
      searchQuery,
      filters: normalizeSelectedFilters(selectedFilters),
      page: normalizePage(page),
      perPage: normalizePerPage(perPage),
    });
